import apiClient from "./apiClient";

export const getChartMemos = (startDate, endDate) => {
    const params = new URLSearchParams();
    if (startDate) params.append("start_date", startDate);
    if (endDate) params.append("end_date", endDate);
    const queryString = params.toString();
    return apiClient.get(`/api/balance/chart-memo${queryString ? `?${queryString}` : ""}`);
};

export const createChartMemo = (memoDate, content, color = "#3B82F6") =>
    apiClient.post("/api/balance/chart-memo", { memo_date: memoDate, content, color });

export const updateChartMemo = (id, content, color) =>
    apiClient.put(`/api/balance/chart-memo/${id}`, { content, color });

export const deleteChartMemo = (id) =>
    apiClient.delete(`/api/balance/chart-memo/${id}`);
